import React, { useEffect, useRef } from "react";

import { Box, LinearProgress, Typography } from "@mui/material";

import { useMap } from "react-map-gl";

import { Site, SiteCatchment } from "@/types";
import { times } from "lodash";

type PenPortraitMapOverlayProps = {
  sites: Site[];
  catchment: SiteCatchment[];
  firstTime: boolean;
  loading: boolean;
};

export const SiteMapOverlay: React.FC<PenPortraitMapOverlayProps> = ({
  sites,
  catchment,
  firstTime,
  loading
}) => {
  const { current: map } = useMap();
  const updateRef = useRef(false);

  useEffect(() => {
    if (!firstTime) {
      map && map.isStyleLoaded() && resetMap();
      map &&
      catchment.forEach((value) => {
        map.setFeatureState(
          {
            id: value.sector_gid,
            source: "sector-source",
            sourceLayer: "postal_sector_test",
          },
          { score: value.score, name: value.sector, category: value.category }
        );
      });
      updateRef.current = true;
    }
  }, [firstTime, map, catchment]);

  useEffect(() => {
    if (!map || catchment.length === 0) return;

    const handleZoom = () => {
      if (updateRef.current) {
        updateRef.current = false;

        // Zoom to the extent of the catchment
        let minX = Infinity;
        let minY = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        catchment.forEach((sector) => {
          if (sector.minx < minX) minX = sector.minx
          if (sector.miny < minY) minY = sector.miny
          if (sector.maxx > maxX) maxX = sector.maxx
          if (sector.maxy > maxY) maxY = sector.maxy
        })
        map.fitBounds([[minX, minY], [maxX, maxY]], {padding: 60, maxZoom: 8, duration: 1800})
      }
    }
    map.once('idle', handleZoom);
    return () => {
      map.off('idle', handleZoom);
    };
  }, [catchment, map]);

  const resetMap = () => {
    map &&
    [...times(9576)].forEach((value) => {
      map.setFeatureState(
        {
          id: value,
          source: "sector-source",
          sourceLayer: "postal_sector_test",
        },
        { score: null, name: null, category: null },
      );
    });
  };

  return (
    <>
      {loading ? (
        <Box sx={{
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
          backgroundColor: "#00000060",
          p: 1
        }}>
          <LinearProgress color="secondary"/>
        </Box>
      ) : (
        sites.length === 0 ?
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#00000060"
          }}
        >
          <Typography sx={{ textAlign: "center" }}>
            Select a site to view its catchment
          </Typography>
        </Box>
      : null
)}
    </>
  );
};
